import { render, staticRenderFns } from "./PrintPlan.vue?vue&type=template&id=4b970808&scoped=true&"
import script from "./PrintPlan.vue?vue&type=script&lang=ts&"
export * from "./PrintPlan.vue?vue&type=script&lang=ts&"
import style0 from "./PrintPlan.vue?vue&type=style&index=0&id=4b970808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b970808",
  null
  
)

export default component.exports